import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { noop } from 'utils'
import { animated, useSpring } from 'react-spring'

const SVGBase = styled.svg`
  display: block;
  transform: rotate(-90deg);
`

const BackgroundCircle = styled.circle`
  fill: none;
  stroke: rgba(0, 0, 0, 0.4);
`

const ForegroundCircle = styled(animated.circle)`
  stroke: #fd9800;
  fill: none;
`

const ProgressCircle = ({
  radius,
  percentage,
  strokeWidth,
  onFinished,
  ...props
}) => {
  const fixedPercentage = Math.min(100, percentage)
  const dashOffset =
    2 * Math.PI * radius - 2 * Math.PI * radius * (fixedPercentage / 100)

  const springProps = useSpring({
    dashOffset,
    onRest: () => {
      if (fixedPercentage >= 100) {
        onFinished()
      }
    },
  })

  const centerDistance = radius + strokeWidth / 2

  return (
    <SVGBase
      width={radius * 2 + strokeWidth}
      height={radius * 2 + strokeWidth}
      {...props}>
      <BackgroundCircle
        cx={centerDistance}
        cy={centerDistance}
        r={radius}
        strokeWidth={strokeWidth}
      />
      <ForegroundCircle
        cx={centerDistance}
        cy={centerDistance}
        r={radius}
        strokeWidth={strokeWidth}
        strokeDasharray={2 * Math.PI * radius}
        strokeDashoffset={springProps.dashOffset}
      />
    </SVGBase>
  )
}

ProgressCircle.propTypes = {
  percentage: PropTypes.number.isRequired,
  radius: PropTypes.number,
  strokeWidth: PropTypes.number,
  onFinished: PropTypes.func,
}

ProgressCircle.defaultProps = {
  strokeWidth: 2,
  radius: 75,
  onFinished: noop,
}

export default ProgressCircle
